import { Box } from '../Box'

interface FieldWrapperProps {
  children: React.ReactNode
  fullwidth?: boolean
  className?: string
  direction?: 'row' | 'column'
}

export const FieldWrapper = ({
  children,
  fullwidth,
  className,
  direction = 'column',
}: FieldWrapperProps) => {
  return (
    <Box flex direction={direction} gap='x12' fullWidth={fullwidth} className={className}>
      {children}
    </Box>
  )
}
